import React from 'react';
import styles from './Radio.module.scss';
import { Icon } from 'antd';

export const Radio = ({
  checked,
  onChange,
  value,
  name,
  children,
  className,
  icon,
  action,
  ...props
}) => {
  const handleClick = (e) => {
    if (checked && onChange) {
      onChange({
        target: { name, value, checked: false },
      });
    }
  };

  const handleActionClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <label className={`${styles.root} ${className || ''}`.trim()}>
      {icon && (
        <span className={styles.anticon}>
          <Icon
            className={styles.icon}
            component={icon}
          />
        </span>
      )}
      <input
        type="radio"
        className={styles.input}
        checked={checked}
        onChange={onChange}
        onClick={handleClick}
        value={value}
        name={name}
        {...props}
      />
      {children}

      {action && (
        <span
          className={styles.action}
          onClick={handleActionClick}
        >
          {action}
        </span>
      )}
    </label>
  );
};
